var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classnames},[(this.$slots.default)?[_c('node-decorator',{attrs:{"focusedTabId":_vm.focusedTabId}},[_c('node-filterer',{attrs:{"nodes":this.$slots.default,"render":['tabs-nav-item']}})],1)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21059047","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Tabs/TabsNav.vue
// module id = 4ZFX
// module chunks = 1